import { AxiosInstance } from "axios";
import { ApiService } from '../model/Api.model';
import { IDealQuestion } from '../interface/deal/IDealQuestion';

enum DealQuestionServiceEnum {
  save = "",
  getQuestionsByDealId = "/get-questions",
  getQuestionsByQuestionId = "/get-messages",
  closeQuestion = "/close-question"
}

export default class DealQuestionService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/deal/question");
  }

  public save = async (body: IDealQuestion): Promise<IDealQuestion> => await this.POST(`${DealQuestionServiceEnum.save}`, body);
  public getQuestionsByDealId = async (dealId: number): Promise<IDealQuestion[]> => await this.GET(`${DealQuestionServiceEnum.getQuestionsByDealId}/${dealId}`);
  public getQuestionsByQuestionId = async (questionId: number): Promise<IDealQuestion[]> => await this.GET(`${DealQuestionServiceEnum.getQuestionsByQuestionId}/${questionId}`);
  public closeQuestion = async (questionId: number): Promise<any> =>
    await this.POST(DealQuestionServiceEnum.closeQuestion + "?questionId=" + questionId, null);
}
